// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  /* min-width: 1000px; */
  width: 100%;
  text-align: center;
  position: relative;
}

a {
  text-decoration: none;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

*::-webkit-scrollbar {
  display: none;
}


/* paging */
.main-paging {
  text-align: right;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 20px 24px;
  width: calc(100% - 48px);
}

.main-paging-pages>span {
  /* width: 24px;
  height: 24px; */
  margin-left: 6px;
  min-width: auto;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  border: 1px solid #d5dae0;
  border-radius: 4px;
  outline: 0px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  padding: 5px 10px;
  transition: none 0s ease 0s;
  font-size: 12px;
  /* line-height: 22px; */
  color: #121214;
}

.main-paging-pages>span:hover {
  background-color: #d7d7d7;
  color: #121212;
}

.main-paging-pages.dark>span {
  color: #fff;
  border: 1px solid #444444;
}

.main-paging-pages.dark>span:hover {
  background-color: #d7d7d7;
  color: #121212;
}

.main-paging-btn {
  width: 30px;
  height: 29px;
  margin-left: 6px;
  min-width: auto;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  border: 1px solid #d5dae0;
  border-radius: 4px;
  outline: 0px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  padding: 0px;
  transition: none 0s ease 0s;
  font-size: 12px;
  line-height: 29px;
  color: #121214;
}

.main-paging-btn.dark {
  border: 1px solid #444444;
  color: #fff;
}

.main-paging-pages>span.active {
  background-color: #d7d7d7;
  font-weight: bold;
}

.main-paging-pages.dark>span.active {
  background-color: #d7d7d7;
  font-weight: bold;
  color: #121212;
}


.regist-box-left-form-3-span1.checked {
  border-color: #003577;
}

.regist-box-left-form-3-span1.checked::before {
  height: 6px;
  transition: all 0.15s ease;
}

.regist-box-left-form-3-span1.checked::after {
  height: 9px;
  transition: all 0.15s ease 0.15s;
}

.regist-box-left-form-3-span1 {
  display: inline-block;
  width: 18px;
  min-width: 18px;
  height: 18px;
  background-color: transparent;
  border: 1px solid #ccc;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
}

.regist-box-left-form-3-span1::before {
  top: 7px;
  left: 2.5px;
  transform: rotate(-45deg);
  content: '';
  display: inline-block;
  width: 1px;
  background: #003577;
  position: absolute;
  transform-origin: left top;
}

.regist-box-left-form-3-span1::after {
  top: 12px;
  left: 7px;
  transform: rotate(228deg);
  content: '';
  display: inline-block;
  width: 1px;
  height: 0;
  background: #003577;
  position: absolute;
  transform-origin: left top;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;;AAGA,WAAW;AACX;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE;iBACe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,SAAS;EACT,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B","sourcesContent":[".App {\n  /* min-width: 1000px; */\n  width: 100%;\n  text-align: center;\n  position: relative;\n}\n\na {\n  text-decoration: none;\n}\n\n* {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\n*::-webkit-scrollbar {\n  display: none;\n}\n\n\n/* paging */\n.main-paging {\n  text-align: right;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 24px;\n  width: calc(100% - 48px);\n}\n\n.main-paging-pages>span {\n  /* width: 24px;\n  height: 24px; */\n  margin-left: 6px;\n  min-width: auto;\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle;\n  list-style: none;\n  border: 1px solid #d5dae0;\n  border-radius: 4px;\n  outline: 0px;\n  cursor: pointer;\n  user-select: none;\n  padding: 5px 10px;\n  transition: none 0s ease 0s;\n  font-size: 12px;\n  /* line-height: 22px; */\n  color: #121214;\n}\n\n.main-paging-pages>span:hover {\n  background-color: #d7d7d7;\n  color: #121212;\n}\n\n.main-paging-pages.dark>span {\n  color: #fff;\n  border: 1px solid #444444;\n}\n\n.main-paging-pages.dark>span:hover {\n  background-color: #d7d7d7;\n  color: #121212;\n}\n\n.main-paging-btn {\n  width: 30px;\n  height: 29px;\n  margin-left: 6px;\n  min-width: auto;\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle;\n  list-style: none;\n  border: 1px solid #d5dae0;\n  border-radius: 4px;\n  outline: 0px;\n  cursor: pointer;\n  user-select: none;\n  padding: 0px;\n  transition: none 0s ease 0s;\n  font-size: 12px;\n  line-height: 29px;\n  color: #121214;\n}\n\n.main-paging-btn.dark {\n  border: 1px solid #444444;\n  color: #fff;\n}\n\n.main-paging-pages>span.active {\n  background-color: #d7d7d7;\n  font-weight: bold;\n}\n\n.main-paging-pages.dark>span.active {\n  background-color: #d7d7d7;\n  font-weight: bold;\n  color: #121212;\n}\n\n\n.regist-box-left-form-3-span1.checked {\n  border-color: #003577;\n}\n\n.regist-box-left-form-3-span1.checked::before {\n  height: 6px;\n  transition: all 0.15s ease;\n}\n\n.regist-box-left-form-3-span1.checked::after {\n  height: 9px;\n  transition: all 0.15s ease 0.15s;\n}\n\n.regist-box-left-form-3-span1 {\n  display: inline-block;\n  width: 18px;\n  min-width: 18px;\n  height: 18px;\n  background-color: transparent;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  position: relative;\n  cursor: pointer;\n}\n\n.regist-box-left-form-3-span1::before {\n  top: 7px;\n  left: 2.5px;\n  transform: rotate(-45deg);\n  content: '';\n  display: inline-block;\n  width: 1px;\n  background: #003577;\n  position: absolute;\n  transform-origin: left top;\n}\n\n.regist-box-left-form-3-span1::after {\n  top: 12px;\n  left: 7px;\n  transform: rotate(228deg);\n  content: '';\n  display: inline-block;\n  width: 1px;\n  height: 0;\n  background: #003577;\n  position: absolute;\n  transform-origin: left top;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
